import React from 'react';

const Footer = () => (
    <footer>
        <ul>
            <li><strong>Phone <a href="tel:0439432224">0439 432 224</a></strong></li>
            <li>|</li>
            <li>Fax 6155 0922</li>
            <li>|</li>
            <li><a href="mailto:paula@paulabramwell.com.au">paula@paulabramwell.com.au</a></li>
            <li>|</li>
            <li>paulabramwell.com.au</li>
            <li>|</li>
            <li>16 Tanunda Drive, Rivervale, Western Australia  6103</li>
        </ul>
    </footer>
)

export default Footer;